import { createSelector } from 'reselect'

export const getAgents = createSelector(
  (state) => state && state.user && state.user.profile && state.user.profile.agents &&
    Array.isArray(state.user.profile.agents.elements) ? state.user.profile.agents.elements : [],
  (agents) => agents
)
